import React, { useEffect } from "react";
import { ChevronDown } from "lucide-react";
import { gsap } from "gsap";
import LocomotiveScroll from "locomotive-scroll";

const Hero = () => {
  useEffect(() => {
    // Initialize Locomotive Scroll
    const scroll = new LocomotiveScroll({
      el: document.querySelector("#home"),
      smooth: true,
    });

    // GSAP Animations
    gsap.fromTo(
      ".animate-title",
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.2, ease: "power3.out", delay: 0.5 }
    );

    gsap.fromTo(
      ".animate-subtitle",
      { y: 50, opacity: 0 },
      { y: 0, opacity: 1, duration: 1.2, ease: "power3.out", delay: 1 }
    );

    gsap.fromTo(
      ".animate-buttons",
      { opacity: 0, scale: 0.8 },
      { opacity: 1, scale: 1, duration: 1, ease: "elastic.out(1, 0.5)", delay: 1.5 }
    );

    return () => {
      scroll.destroy();
    };
  }, []);

  const scrollToServices = () => {
    document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div id="home" className="relative h-screen overflow-hidden" data-scroll-container>
      {/* Parallax background effect */}
      <div
        className="absolute inset-0 bg-cover bg-center hero-background"
        style={{
          backgroundImage:
            'url("https://images.unsplash.com/photo-1541976590-713941681591?ixlib=rb-1.2.1&auto=format&fit=crop&w=2000&q=80")',
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-r from-blue-900/80 to-black/50"></div>
      </div>

      <div className="relative h-full flex items-center justify-center">
        <div className="text-center text-white px-4">
          <h1 className="text-6xl md:text-7xl font-bold mb-6 animate-title">
            Building Your <span className="text-blue-400">Vision</span>
          </h1>
          <p className="text-xl md:text-2xl mt-4 mb-12 animate-subtitle">
            Excellence in Construction & Design Services
          </p>

          <div className="space-x-6 animate-buttons">
            <a
              href="#contact"
              className="bg-blue-600 text-white px-8 py-4 rounded-full text-lg hover:bg-blue-700 transition-all duration-300 transform hover:scale-105 inline-flex items-center shadow-lg border-2 border-blue-600"
            >
              Get Started
            </a>
            <a
              href="#projects"
              className="bg-white text-blue-600 px-8 py-4 rounded-full text-lg hover:bg-blue-100 transition-all duration-300 transform hover:scale-105 inline-flex items-center shadow-lg border-2 border-blue-600"
            >
              View Projects
            </a>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
        <button onClick={scrollToServices} className="text-white">
          <ChevronDown size={32} />
        </button>
      </div>
    </div>
  );
};

export default Hero;
